import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealFilterEntity } from '../../domain/entities/MealFilterEntity'

export class MealFilterFilterModel extends MealFilterEntity {
  serviceId?: number
  companyId?: number
  branchId?: number
  userId?: string
  constructor(dataDto: MealFilterEntity) {
    super()
    mapEntityProperties<MealFilterFilterModel>(this, dataDto, {
      exclude: ['service', 'company', 'branch', 'user'],
      map: {
        serviceId: dataDto.service?.id,
        companyId: dataDto.company?.id,
        branchId: dataDto.branch?.id,
        userId: dataDto.user?.id
      }
    })
  }
}
